/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import Provider from "./src/provider"

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}>
    <Provider>{element}</Provider>
  </GoogleReCaptchaProvider>
)

// https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#onRouteUpdate
// export const onRouteUpdate = ({ location, prevLocation }) => {
//   window.scrollTo(0, 0)
// }
